var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7937 18.1453L14.6437 11.9719L20.8078 5.87815C21.0609 5.62502 21.0609 5.21252 20.8078 4.9594L19.0547 3.1969C18.9328 3.07502 18.7687 3.0094 18.5953 3.0094C18.4219 3.0094 18.2578 3.07971 18.1359 3.1969L12 9.2719L5.85468 3.20159C5.73281 3.07971 5.56874 3.01409 5.39531 3.01409C5.22187 3.01409 5.05781 3.0844 4.93593 3.20159L3.18749 4.96409C2.93437 5.21721 2.93437 5.62971 3.18749 5.88284L9.35156 11.9766L3.20624 18.1453C3.08437 18.2672 3.01406 18.4313 3.01406 18.6047C3.01406 18.7782 3.07968 18.9422 3.20624 19.0641L4.95937 20.8266C5.08593 20.9531 5.24999 21.0188 5.41874 21.0188C5.58281 21.0188 5.75156 20.9578 5.87812 20.8266L12 14.6766L18.1266 20.8219C18.2531 20.9485 18.4172 21.0141 18.5859 21.0141C18.75 21.0141 18.9187 20.9532 19.0453 20.8219L20.7984 19.0594C20.9203 18.9375 20.9906 18.7735 20.9906 18.6C20.9859 18.4313 20.9156 18.2672 20.7937 18.1453Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.93df1e9d57bfb276d3ed5b15a8226b4f.svg";
export { ForwardRef as ReactComponent };